/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CancelMovementIn,
  ChangeClientIn,
  CorrectionOut,
  CorrectionReasonIn,
  ProblemDetail,
  ReceiptEditIn
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Поправить приёмку партии: количество, срок, страна, калибр, поставщик
 */
export const correctionsEditReceipt = (
    batchId: number,
    receiptEditIn: BodyType<ReceiptEditIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<CorrectionOut>(
      {url: `/api/v1/corrections/batches/${batchId}/receipt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: receiptEditIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getCorrectionsEditReceiptMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsEditReceipt>>, TError,{batchId: number;data: BodyType<ReceiptEditIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof correctionsEditReceipt>>, TError,{batchId: number;data: BodyType<ReceiptEditIn>}, TContext> => {

const mutationKey = ['correctionsEditReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctionsEditReceipt>>, {batchId: number;data: BodyType<ReceiptEditIn>}> = (props) => {
          const {batchId,data} = props ?? {};

          return  correctionsEditReceipt(batchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectionsEditReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof correctionsEditReceipt>>>
    export type CorrectionsEditReceiptMutationBody = BodyType<ReceiptEditIn>
    export type CorrectionsEditReceiptMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Поправить приёмку партии: количество, срок, страна, калибр, поставщик
 */
export const useCorrectionsEditReceipt = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsEditReceipt>>, TError,{batchId: number;data: BodyType<ReceiptEditIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctionsEditReceipt>>,
        TError,
        {batchId: number;data: BodyType<ReceiptEditIn>},
        TContext
      > => {

      const mutationOptions = getCorrectionsEditReceiptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Отменить ошибочное списание или корректировку партии
 */
export const correctionsCancelMovement = (
    movementId: number,
    cancelMovementIn: BodyType<CancelMovementIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<CorrectionOut>(
      {url: `/api/v1/corrections/movements/${movementId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelMovementIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getCorrectionsCancelMovementMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsCancelMovement>>, TError,{movementId: number;data: BodyType<CancelMovementIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof correctionsCancelMovement>>, TError,{movementId: number;data: BodyType<CancelMovementIn>}, TContext> => {

const mutationKey = ['correctionsCancelMovement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctionsCancelMovement>>, {movementId: number;data: BodyType<CancelMovementIn>}> = (props) => {
          const {movementId,data} = props ?? {};

          return  correctionsCancelMovement(movementId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectionsCancelMovementMutationResult = NonNullable<Awaited<ReturnType<typeof correctionsCancelMovement>>>
    export type CorrectionsCancelMovementMutationBody = BodyType<CancelMovementIn>
    export type CorrectionsCancelMovementMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Отменить ошибочное списание или корректировку партии
 */
export const useCorrectionsCancelMovement = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsCancelMovement>>, TError,{movementId: number;data: BodyType<CancelMovementIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctionsCancelMovement>>,
        TError,
        {movementId: number;data: BodyType<CancelMovementIn>},
        TContext
      > => {

      const mutationOptions = getCorrectionsCancelMovementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Сменить клиента или точку доставки у отгрузки
 */
export const correctionsChangeClient = (
    historyId: number,
    changeClientIn: BodyType<ChangeClientIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<CorrectionOut>(
      {url: `/api/v1/corrections/shipment-history/${historyId}/client`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeClientIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getCorrectionsChangeClientMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsChangeClient>>, TError,{historyId: number;data: BodyType<ChangeClientIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof correctionsChangeClient>>, TError,{historyId: number;data: BodyType<ChangeClientIn>}, TContext> => {

const mutationKey = ['correctionsChangeClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctionsChangeClient>>, {historyId: number;data: BodyType<ChangeClientIn>}> = (props) => {
          const {historyId,data} = props ?? {};

          return  correctionsChangeClient(historyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectionsChangeClientMutationResult = NonNullable<Awaited<ReturnType<typeof correctionsChangeClient>>>
    export type CorrectionsChangeClientMutationBody = BodyType<ChangeClientIn>
    export type CorrectionsChangeClientMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Сменить клиента или точку доставки у отгрузки
 */
export const useCorrectionsChangeClient = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsChangeClient>>, TError,{historyId: number;data: BodyType<ChangeClientIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctionsChangeClient>>,
        TError,
        {historyId: number;data: BodyType<ChangeClientIn>},
        TContext
      > => {

      const mutationOptions = getCorrectionsChangeClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Вернуть ошибочно отменённую отгрузку в черновик
 */
export const correctionsRestoreCancelled = (
    historyId: number,
    correctionReasonIn: BodyType<CorrectionReasonIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<CorrectionOut>(
      {url: `/api/v1/corrections/shipment-history/${historyId}/restore`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: correctionReasonIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getCorrectionsRestoreCancelledMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsRestoreCancelled>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof correctionsRestoreCancelled>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext> => {

const mutationKey = ['correctionsRestoreCancelled'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctionsRestoreCancelled>>, {historyId: number;data: BodyType<CorrectionReasonIn>}> = (props) => {
          const {historyId,data} = props ?? {};

          return  correctionsRestoreCancelled(historyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectionsRestoreCancelledMutationResult = NonNullable<Awaited<ReturnType<typeof correctionsRestoreCancelled>>>
    export type CorrectionsRestoreCancelledMutationBody = BodyType<CorrectionReasonIn>
    export type CorrectionsRestoreCancelledMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Вернуть ошибочно отменённую отгрузку в черновик
 */
export const useCorrectionsRestoreCancelled = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsRestoreCancelled>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctionsRestoreCancelled>>,
        TError,
        {historyId: number;data: BodyType<CorrectionReasonIn>},
        TContext
      > => {

      const mutationOptions = getCorrectionsRestoreCancelledMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Отменить последний шаг приёмки клиентом — отгрузка снова «Отгружено клиенту»
 */
export const correctionsUndoAcceptance = (
    historyId: number,
    correctionReasonIn: BodyType<CorrectionReasonIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<CorrectionOut>(
      {url: `/api/v1/corrections/shipment-history/${historyId}/undo-acceptance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: correctionReasonIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getCorrectionsUndoAcceptanceMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsUndoAcceptance>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof correctionsUndoAcceptance>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext> => {

const mutationKey = ['correctionsUndoAcceptance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctionsUndoAcceptance>>, {historyId: number;data: BodyType<CorrectionReasonIn>}> = (props) => {
          const {historyId,data} = props ?? {};

          return  correctionsUndoAcceptance(historyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectionsUndoAcceptanceMutationResult = NonNullable<Awaited<ReturnType<typeof correctionsUndoAcceptance>>>
    export type CorrectionsUndoAcceptanceMutationBody = BodyType<CorrectionReasonIn>
    export type CorrectionsUndoAcceptanceMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Отменить последний шаг приёмки клиентом — отгрузка снова «Отгружено клиенту»
 */
export const useCorrectionsUndoAcceptance = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctionsUndoAcceptance>>, TError,{historyId: number;data: BodyType<CorrectionReasonIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctionsUndoAcceptance>>,
        TError,
        {historyId: number;data: BodyType<CorrectionReasonIn>},
        TContext
      > => {

      const mutationOptions = getCorrectionsUndoAcceptanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    